/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import React, { Component, Fragment } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Cleave from 'cleave.js/react'
import Spinner from '../../components/Spinner'
import Button from '../../components/Button'
import Card from '../../components/Card'
import * as actionCreators from '../../root/actions'
import { LOGIN_URL, USER_URL } from '../../api/endpoints'

export class Passcode extends Component {
  state = {
    isSubmitting: false
  }

  render() {
    const { passcode, app } = this.props.containers

    return (
      <Card>
        <form onSubmit={this.onSubmit} className="passcode-form mobile-padding">
          {passcode.get('isLoading') && app.get('isMobile') ? (
            <Spinner />
          ) : (
            this.renderView()
          )}
        </form>
      </Card>
    )
  }

  UNSAFE_componentWillMount() {
    const { phone } = this.props.containers
    if (!phone.get('value')) this.props.changeRoute({ route: '/phone' })
  }

  renderView() {
    const { passcode, phone } = this.props.containers
    const { setPasscode } = this.props

    return (
      <Fragment>
        <div style={{ alignSelf: 'flex-start' }}>
          <span className="medium-weight">Confirmation Code</span>

          <br />
          <span className="light-weight">
            Please enter the code sent to {phone.get('value')}.
          </span>
        </div>

        <Cleave
          placeholder="000-000"
          autoComplete="one-time-code"
          autoFocus
          required
          type="tel"
          options={{
            delimiter: '-',
            blocks: [3, 3],
            numericOnly: true
          }}
          className="underlineText"
          value={passcode.get('value')}
          onChange={({ target }) => {
            setPasscode(target.value)
          }}
        />
        <div>
          {passcode.get('isLoading') ? (
            <Spinner />
          ) : (
            <div>
              <Button
                disabled={!!passcode.get('isLoading') || !passcode.get('value')}
                type="submit"
                fullWidth
                fixed
              >
                Next
              </Button>
            </div>
          )}
        </div>
      </Fragment>
    )
  }

  onSubmit = e => {
    e.preventDefault()
    const { passcode, phone } = this.props.containers

    if (this.state.isSubmitting || passcode.get('value') === '') return
    this.setState({ isSubmitting: true })

    const { apiRequest, setUser, changeRoute } = this.props

    const onGetUserSuccess = result => {
      setUser(result.data.data)
      const isActive = result.data.data.active

      this.setState({ isSubmitting: false }, () => {
        if (!isActive) changeRoute({ route: '/activation' })
        else changeRoute({ route: '/' })
      })
    }

    const onLoginSuccess = _result => {
      const request = {
        url: USER_URL,
        method: 'get'
      }

      const meta = {
        Component: 'Passcode',
        onSuccess: onGetUserSuccess
      }

      apiRequest(request, meta)
    }

    const formattedPasscode = passcode.get('value').replace(/-/g, '')

    const request = {
      url: LOGIN_URL,
      data: { phone: phone.get('value'), code: formattedPasscode },
      method: 'post'
    }

    const meta = {
      ignoreAuth: true,
      Component: 'Passcode',
      onSuccess: onLoginSuccess,
      onError: () => this.setState({ isSubmitting: false })
    }

    apiRequest(request, meta)
  }
}

const mapStateToProps = state => {
  const { containers } = state

  return {
    containers
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(actionCreators, dispatch)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Passcode)
